export default __webpack_public_path__ + "static/media/logo-buggy-color-sec.1c541338.svg";